import { axiosObject } from "../config";

function updateInterestedCount(payload: any) {
    return new Promise((resolve, reject) => {
        let uri = "auction/data/resource/properties/_patch";
        let data = {
            uuid: payload.uuid,
            interested_count: payload.count,
            apiConfig: {
                includeRelations: "*",
                includeMutations: "*"
            }
        }
        axiosObject
            .post(uri, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((errors) => {
                reject(errors);
            });
    });
}

function updateViewCount(payload: any) {
    return new Promise((resolve, reject) => {
        let uri = "auction/data/resource/properties/_patch";
        let data = {
            uuid: payload.uuid,
            view_count: payload.count,
            apiConfig: {
                includeRelations: "*",
                includeMutations: "*"
            }
        }
        axiosObject
            .post(uri, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((errors) => {
                reject(errors);
            });
    });
}

export { updateInterestedCount, updateViewCount }
